import React, { useEffect, useMemo, useState } from "react";
import InputSearch from "../../common/InputSearch";
import { toast } from "react-toastify";
import DataTableBase from "../../common/Datatable";
import moment from "moment";
import { Link, useSearchParams } from "react-router-dom";
import { SENSOR_STATUS_CLASS_MAPPING } from "../contants";
import makeRequest from "../../../../api";
import { cgmService } from "../../../../api/services";
import Select from "react-select";
import { cgmStatusOptions } from "./constants";

const AllCGMUsersComponent = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [allCGMUsers, setAllCGMUsers] = useState<any[]>([]);
  const [searchedTerm, setSearchedTerm] = useState("");
  const [cgmStatus, setCGMStatus] = useState("");
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);

  const fetchAllCGMUsers = async () => {
    try {
      const res = await makeRequest(cgmService.getCGMUsersList());
      const response = res?.data?.body?.cgmUsersInfoList || [];
      setAllCGMUsers([...response]);
    } catch (error: any) {
      toast.error("Error fetching CGM users list");
    }
  };

  useEffect(() => {
    fetchAllCGMUsers();
  }, []);

  useEffect(() => {
    const cgmStatus = searchParams?.get("cgmStatus");
    if (!!cgmStatus?.length) {
      setCGMStatus(cgmStatus);
    } else {
      setCGMStatus("");
    }
  }, [searchParams]);

  useEffect(() => {
    if (allCGMUsers?.length > 0) {
      let users = allCGMUsers;
      const searchTerm = searchedTerm?.trim();
      const status = cgmStatus?.trim();
      if (searchTerm?.length > 0) {
        users = users?.filter(
          (item: any) =>
            item?.userId === searchTerm ||
            item?.userName?.toLowerCase()?.includes(searchTerm?.toLowerCase())
        );
      }
      if (status?.length > 0) {
        users = users?.filter((item: any) => item?.sensorStatus === status);
        setSearchParams({ cgmStatus });
      } else {
        setSearchParams({});
      }
      setFilteredUsers([...users]);
    }
  }, [allCGMUsers, searchedTerm, cgmStatus]);

  const columns = useMemo(
    () => [
      {
        name: "User Name",
        selector: (row: any) => row.userName,
        cell: (row: any) => {
          return <div>{row?.userName || "Anonymous user"}</div>;
        },
        sortable: true,
        width: "20%",
      },
      {
        name: "Start date",
        selector: (row: any) => row?.sensorStartTs,
        cell: (row: any) => {
          return (
            <div>
              {row?.sensorStartTs
                ? moment(row?.sensorStartTs).format("DD MMM YY, hh:mm a")
                : "-"}
            </div>
          );
        },
        sortable: true,
        width: "15%",
      },
      {
        name: "Expiry date",
        selector: (row: any) => row?.sensorExpiryTs,
        cell: (row: any) => {
          return (
            <div>
              {row?.sensorExpiryTs
                ? moment(row?.sensorExpiryTs).format("DD MMM YY, hh:mm a")
                : "-"}
            </div>
          );
        },
        sortable: true,
        width: "15%",
      },
      {
        name: "Last scan time",
        selector: (row: any) => row?.lastScannedAt,
        cell: (row: any) => {
          return (
            <div>
              {row?.lastScannedAt
                ? moment(row?.lastScannedAt).format("DD MMM YY, hh:mm a")
                : "-"}
            </div>
          );
        },
        sortable: true,
        width: "15%",
      },
      {
        name: "Value",
        selector: (row: any) => row.glucoseValue,
        cell: (row: any) => {
          return <div>{row?.glucoseValue || "-"}</div>;
        },
        width: "10%",
      },
      {
        name: "Status",
        selector: (row: any) => row.sensorStatus,
        cell: (row: any) => {
          return (
            <div
              className={`text-capitalise ${
                SENSOR_STATUS_CLASS_MAPPING[row.sensorStatus]
              } fw-600 text-center w-100`}
            >
              {row?.sensorStatus}
            </div>
          );
        },
        width: "12.5%",
      },
      {
        name: "Action",
        selector: (row: any) => row.userId,
        cell: (row: any) => {
          return (
            <div>
              <Link
                to={`/users/${row?.userId}/cgm-details`}
                className="btn btn-sm btn-outline-success"
              >
                CGM
              </Link>
            </div>
          );
        },
        width: "12.5%",
      },
    ],
    []
  );

  return (
    <>
      <div className="header d-flex align-items-center justify-content-between mb-3">
        <h6 className="fw-700 fs-24 mb-0">All CGM users</h6>
        <InputSearch
          placeholder="Search user by name or userId"
          value={searchedTerm}
          setValue={setSearchedTerm}
        />
      </div>
      <div className="mb-4">
        <h6>Filters: </h6>
        <div className="row">
          <div className="col-4">
            <Select
              onChange={(option: any) => {
                setCGMStatus(option?.value);
              }}
              value={cgmStatusOptions.find((x: any) => x.value === cgmStatus)}
              className="basic-single"
              classNamePrefix="select"
              name="cgm-status"
              options={cgmStatusOptions}
              placeholder="Select CGM Status"
            />
          </div>
        </div>
      </div>

      <DataTableBase data={filteredUsers} columns={columns} />
    </>
  );
};

export default AllCGMUsersComponent;
